import { QUERY_KEYS } from '@24i/nxg-sdk-photon';

export const getMenuConfigQueryKey = (menuId?: string) =>
    menuId ? [QUERY_KEYS.menu, menuId] : QUERY_KEYS.menu;
